export default __webpack_public_path__ + "static/media/linkedinQR.19012182.png";